module.exports = __webpack_public_path__ + "assets/Social-facebook-accent.9858aa9d.svg";